// extracted by mini-css-extract-plugin
module.exports = {"returnsQrCode":"styles_returnsQrCode__2y9fK","returnsQrCode__container":"styles_returnsQrCode__container__jYl91","returnsQrCode__title":"styles_returnsQrCode__title__4xdaw"};